import ApiClient from './ApiClient';
import AlibabaRamUser from '../models/AlibabaRamUser';
import AlibabaRamResetPw from '../models/AlibabaRamResetPw';
import { AlibabaFirewallResponse } from '../models/AlibabaFirewallResponse';

export default class AlibabaCloudService extends ApiClient {
    async getRamUserEmail() {
        return this.get<AlibabaRamUser[]>(`Alibaba/GetRamUserEmail`);
    }

    async getResetPassword(accountId: string, userPrincipalName: string) {
        const encodedAccountId = encodeURIComponent(accountId);
        const encodedUPN = encodeURIComponent(userPrincipalName);
        return this.get<AlibabaRamResetPw>(
            `Alibaba/GetResetPassword?accountId=${encodedAccountId}&userPrincipalName=${encodedUPN}`
        );
    }
    
    async getFirewallData() {
        return this.get<AlibabaFirewallResponse[]>(`Alibaba/GetPortOpening`);
    }
}
